module.exports = __webpack_public_path__ + "static/media/Tres@3x.fdb9b007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tres@3x.png
// module id = 178
// module chunks = 0